import React from 'react';
import { MdVisibility } from 'react-icons/md';
import PortalButton from './PortalButton';
import { usePortalDocumentPreview } from '../hooks';
import { ErrorNotice } from './Feedback';

export default function DocumentPreviewButton({ applicationId, documentId }) {
  const preview = usePortalDocumentPreview(`inscricoes/${applicationId}/documentos/${documentId}/visualizar`);
  return <div>
    <PortalButton className="btn btn-secondary hidethis" type="button" disabled={preview.isLoading || !preview.allowed}
      onClick={() => {
        const tab = window.open('', '_blank');
        if (tab) tab.opener = null;
        preview.mutate(undefined, {
          onSuccess: url => { if (tab) tab.location.replace(url); else window.location.assign(url); },
          onError: () => { if (tab) tab.close(); },
        });
      }}><MdVisibility /> Visualizar documento</PortalButton>
    <ErrorNotice error={preview.error} />
  </div>;
}
